import React, { Component } from 'react';
import Carousel from '../../Carousel/Carousel';
import { connect } from 'react-redux';
import getSetCookie from '../../../../cookie';
import './DittoCarousal.scss';

class DittoCarousal extends Component {
  constructor() {
    super();
    this.state = {
      selectedItemIndex: '',
    };
  }

  componentDidMount() {
    if (getSetCookie.getCookie('isDittoID') !== '') {
      const id = getSetCookie.getCookie('isDittoID');
      (() => {
        this.setState({ selectedItemIndex: id });
      })();
    }
  }

  changeCarouselSlide(dittoId, index, headTurnImage) {
    const { setDittoComponentState, setRotateImageProps } = this.props;
    this.setState({ selectedItemIndex: index });
    if (dittoId && dittoId !== null) {
      setDittoComponentState(dittoId);
    } else {
      setRotateImageProps(headTurnImage);
    }
  }

  render() {
    const {
      dittoProfileAuthImages,
      dittoProfile,
      productData,
      fnCreateMyDitto,
      dittoCreateNewBtn,
      loginStatus,
      dataLocale,
    } = this.props;
    const { HEAD_TURN_IMAGE_FEMALE, HEAD_TURN_IMAGE_MALE } = dataLocale;
    const { selectedItemIndex } = this.state;
    const getDittoProfile = dittoProfile && dittoProfile.result;
    const processData = [];
    const dittoId = getSetCookie.getCookie('isDittoID');
    processData.push(
      <div
        key="ditto-create-btn"
        aria-label="try on btn"
        className="create-new-btn fs11 margin-r5 fw600 text-center bora-4"
        onClick={() => fnCreateMyDitto('Try On', productData)}
      >
        {dittoCreateNewBtn}
      </div>
    );
    if (productData?.headturnFemale || productData?.headturnMale) {
      const headturnFemale = productData.headturnFemale;
      const headturnMale = productData.headturnMale;
      if (headturnFemale) {
        processData.push(
          <div key="head-turn-female">
            <span
              key="setRotateImageFemale"
              aria-label={HEAD_TURN_IMAGE_FEMALE}
              className={`rotate-thumbnail-btn display-ib bora-4 ${
                selectedItemIndex.toString() === 'female' ? 'border-cyan' : 'border-gray'
              }`}
              style={{
                backgroundImage: `url(${productData.headturnFemale})`,
                backgroundPosition: '-295px 0',
              }}
              onClick={() => this.changeCarouselSlide(null, 'female', productData.headturnFemale)}
            />
          </div>
        );
      }
      if (headturnMale) {
        processData.push(
          <div key="head-turn-male">
            <span
              key="setRotateImageMale"
              aria-label={HEAD_TURN_IMAGE_MALE}
              className={`rotate-thumbnail-btn thumbnail-btn display-ib bora-4 ${
                selectedItemIndex.toString() === 'male' ? 'border-cyan' : 'border-gray'
              }`}
              style={{
                backgroundImage: `url(${productData.headturnMale})`,
                backgroundPosition: '-295px 0',
              }}
              onClick={() => this.changeCarouselSlide(null, 'male', productData.headturnMale)}
            />
          </div>
        );
      }
    }
    if (!loginStatus) {
      processData.push(
        <div
          key="ditto-thumbnail"
          aria-label="show ditto thumbnail"
          className="dittoThumbnails"
          onClick={() => this.changeCarouselSlide(dittoId, 'recentDitto')}
        >
          <div
            className={`${
              selectedItemIndex === 'recentDitto' || selectedItemIndex === dittoId
                ? 'border-cyan'
                : 'border-gray'
            } dittoThumbnails_child bora-4`}
            id="ditto-thumbnail"
          />
        </div>
      );
    }
    if (getDittoProfile && getDittoProfile.dittoId) {
      getDittoProfile.dittoId.forEach((ditto, index) => {
        processData.push(
          <div
            key={ditto.created + index}
            className={`${
              selectedItemIndex === index || selectedItemIndex === ditto.id
                ? 'border-cyan'
                : 'border-gray'
            } dittoProfiles_list_item bora-4`}
            onClick={() => this.changeCarouselSlide(ditto.id, index)}
          >
            {dittoProfileAuthImages && (
              <img alt={`My Ditto#${index + 1}`} src={dittoProfileAuthImages[index]} />
            )}
          </div>
        );
      });
    }
    const carouselConfig = {
      slidesToShow: processData.length < 7 ? processData.length : 7,
      autoplay: false,
      dots: false,
      infinite: false,
      useTransform: false,
    };
    return (
      <Carousel
        carouselConfig={carouselConfig}
        carouselHtmlData={processData}
        carouselStyle="custom-zoom-image ditto-carousal"
      />
    );
  }
}

const mapStateToProps = state => ({
  dittoProfile: state.common.dittoProfile,
  dittoProfileAuthImages: state.common.dittoProfileAuthImages,
  refreshDittoProfile: state.common.refreshDittoProfile,
  dataLocale: state.locale,
});

export default connect(mapStateToProps)(DittoCarousal);
